// extracted by mini-css-extract-plugin
module.exports = {"closedRegistrationMessageContainer":"_3agFC","closedRegistrationMessage":"_1Mn1K"};